import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import { TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';
import {
    OR_RRF_TextArea as TextArea
    , OR_RRF_Select as Select
    , ORFButton as Button
    , ORFSearchSuggestions as SearchSuggestions
} from '../../../../../../common/forms/order-request-form.component';
import { newCircuitExhibitBActions } from "./../../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-exhibit-b.reducer";
import { requestLogActions } from "./../../../../../../../store/external/request-reducer/request-log.reducer";
import { createRequestActions } from "./../../../../../../../store/external/request-reducer/create-request.reducer";
import { fileAttachmentActions } from "./../../../../../../../store/external/common-reducer/file-attachment.reducer";
import FileAttachment from '../../../../../../common/file-attachment/file-attachment.component';

class WirelineBusinessFormB extends Component {
    constructor(props) {
        super(props);
    }

    submitRequest = async () => {
        const { modalMessage, submitRequest, fetchRequestLogItems, uploadFile, saveOrderFile } = this.props;

        var success = await submitRequest();
        if (success.Success) {
            var res = await uploadFile(success.OrderId);
            if (res != null && res.Result) {
                saveOrderFile(success.OrderId, res.FileNames);
            }

            fetchRequestLogItems(0);
        }

        modalMessage(success);
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {
        const {
            // component props
            prevAction
            , onClickCancel
            //form
            , wirelineBusinessFormB
            //reducer action
            , onApproverSelect
            , fetchEmployeeByValue
        } = this.props;
        const { employeeList } = this.props.createRequest;
        const { purposeOfUseOptions, formSubmitted } = this.props.newCircuitExhibitBRequest;

        return (
            <div>

                <Form method="post" role="form"
                    model="wirelineBusinessFormB"
                    onSubmit={this.submitRequest}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <SearchSuggestions
                                value={wirelineBusinessFormB.wireLineApprover}
                                label={`${this.toLocaleLanguage('approver')} *`}
                                propDisplay={'Name'}
                                options={employeeList.length > 0 ? employeeList : ''}
                                onChangeAction={onApproverSelect}
                                searchAction={fetchEmployeeByValue}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('purpose_of_use')} *`}
                                options={purposeOfUseOptions}
                                placeholder={this.toLocaleLanguage('select_purpose')}
                                fieldProp='.purposeOfUseId'
                                value={wirelineBusinessFormB.purposeOfUseId}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea
                                label={this.toLocaleLanguage('additional_information')}
                                fieldProp='.additionalInformation'
                                value={wirelineBusinessFormB.additionalInformation}
                                maxLength={350}
                            />
                        </Col>
                    </Row>
                    <FileAttachment />
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <Button
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <Button
                                    label={this.toLocaleLanguage('back')}
                                    variant={"outline-secondary"}
                                    action={prevAction}
                                />
                            </div>
                            <div>
                                <Button
                                    type={"submit"}
                                    label={this.toLocaleLanguage('submit_request_button')}
                                    variant={"primary"}
                                    disabled={wirelineBusinessFormB.wireLineApproverId == 0
                                        || wirelineBusinessFormB.purposeOfUseId == 0
                                        || formSubmitted
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};
export default connect(
    state => {
        const { newCircuitExhibitBRequest, createRequest, translation } = state;
        const { wirelineBusinessFormB } = state.form;
        return {
            newCircuitExhibitBRequest
            , createRequest
            , wirelineBusinessFormB
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newCircuitExhibitBActions, requestLogActions, createRequestActions, fileAttachmentActions),
            dispatch
        )
)(WirelineBusinessFormB);